import message from '@/common/message';

export default {
  install(Vue: any) {
    Vue.prototype.$msg = message;
  }
};
